import { Controller } from "@hotwired/stimulus"

const GAP = 10

// While the sidebar is folded into the icon rail, hovering or focusing an
// item with data-tip shows its name beside it, outside the rail so the
// rail's scroll never clips it.
export default class extends Controller {
  connect() {
    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)

    this.element.addEventListener("mouseover", this.show)
    this.element.addEventListener("focusin", this.show)
    this.element.addEventListener("mouseout", this.hide)
    this.element.addEventListener("focusout", this.hide)
    this.element.addEventListener("click", this.hide)
  }

  disconnect() {
    this.element.removeEventListener("mouseover", this.show)
    this.element.removeEventListener("focusin", this.show)
    this.element.removeEventListener("mouseout", this.hide)
    this.element.removeEventListener("focusout", this.hide)
    this.element.removeEventListener("click", this.hide)
    this.tip?.remove()
  }

  show(event) {
    const item = event.target.closest(".side [data-tip]")

    if (!item || this.element.dataset.sidebar !== "closed" || window.matchMedia("(max-width: 760px)").matches) return

    const box = item.getBoundingClientRect()

    this.tip ||= Object.assign(document.createElement("div"), { className: "rail-tip", role: "tooltip" })
    this.tip.textContent = item.dataset.tip
    this.tip.style.left = `${box.right + GAP}px`
    this.tip.style.top = `${box.top + box.height / 2}px`
    this.element.appendChild(this.tip)
  }

  hide(event) {
    if (event.type === "mouseout" && event.relatedTarget && event.target.closest("[data-tip]")?.contains(event.relatedTarget)) return

    this.tip?.remove()
  }
}
